import { BaseIcon } from './BaseIcon';

const FourWayDotIcon = (props) => {
  return (
    <BaseIcon {...props}>
      <circle cx="10" cy="3.5" r="2.5" stroke="#545454" strokeOpacity="0.7" />
      <circle cx="16.5" cy="10" r="2.5" stroke="#545454" strokeOpacity="0.7" />
      <circle cx="10" cy="16.5" r="2.5" stroke="#545454" strokeOpacity="0.7" />
      <circle cx="3.5" cy="10" r="2.5" stroke="#545454" strokeOpacity="0.7" />
    </BaseIcon>
  );
};

export default FourWayDotIcon;
